import { Injectable, inject } from '@angular/core';
import { UiStateFacade } from '@app/+state/ui-state/store';
import { ConfigService, CoreConfiguration } from '@rockwell-automation-inc/service';
import { AppInsightsMonitoringService } from './app-insights-monitoring.service';
import {
  CommandRequest,
  DomainEventName,
  DomainEvents,
  EventPredicate,
  IDomainUpdateRequestBuilderOptions,
} from './command-request.service';
import { DataService } from './data.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class CommandRequestBuilderService {
  private readonly configService = inject<ConfigService<CoreConfiguration>>(ConfigService);
  private readonly logger = inject(LoggerService);
  private readonly dataService = inject(DataService);
  private readonly uiStateFacade = inject(UiStateFacade);
  private readonly appInsightsMonitoringService = inject(AppInsightsMonitoringService);

  new<T = any>(
    apiPath: string,
    method: 'POST' | 'DELETE' | 'PUT' | 'PATCH',
    domainEvent?: EventPredicate | DomainEventName | DomainEvents,
    options: IDomainUpdateRequestBuilderOptions = {} as IDomainUpdateRequestBuilderOptions,
  ): CommandRequest<T> {
    this.logger.log('creating CommandRequestService instance for apiPath: ', apiPath);
    const apiEndPoint = this.configService.config.csApiBaseUrl + apiPath;
    const services = {
      dataService: this.dataService,
      logger: this.logger,
      uiStateFacade: this.uiStateFacade,
      appInsightsMonitoringService: this.appInsightsMonitoringService,
    };

    return new CommandRequest<T>(apiEndPoint, method, options, services, domainEvent);
  }
}
